import { withJsonFormsControlProps } from "@jsonforms/react";
import { InputItem } from "pepsico-ds";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getTranslatedText } from "../../../utils/commons";

const SearchInputComponent = (props) => {
  const { t } = useTranslation();
  const { handleChange, uischema, path, data } = props;
  const { placeholder, size } = uischema;

  const returnArray = uischema?.returnArray || uischema?.options?.returnArray;

  const externalValue = Array.isArray(data) ? data[0] || "" : data || "";

  // Local state so each keystroke is reflected immediately, without waiting
  // for the round-trip through JsonForms store → context state → props.
  // This prevents characters from disappearing when typing fast.
  const [localValue, setLocalValue] = useState(externalValue);

  // Track whether the last change originated from user input so we don't
  // overwrite a mid-flight local value with the echoed-back external value.
  const isUserTypingRef = useRef(false);

  useEffect(() => {
    // Sync from external source only when the value was NOT just set by the
    // user (e.g. "Clear filters" resets the data prop to "").
    if (!isUserTypingRef.current) {
      setLocalValue(externalValue);
    }
    isUserTypingRef.current = false;
  }, [externalValue]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Mark that this change came from the user so the effect above skips the
    // next external sync (which would echo back the same value via the store).
    isUserTypingRef.current = true;
    setLocalValue(inputValue);

    if (returnArray) {
      const value = inputValue.trim() === "" ? [] : [inputValue];
      handleChange(path, value);
    } else {
      handleChange(path, inputValue);
    }
  };

  return (
    <div className="search-input-container mt-2 w-100 position-relative">
      <InputItem
        title={getTranslatedText(t, placeholder, placeholder)}
        placeholder={getTranslatedText(t, placeholder, placeholder) || ""}
        trailingIcon="search"
        inputSize={size || "medium"}
        value={localValue}
        className="input-search"
        onChange={handleInputChange}
      />
    </div>
  );
};

export const SearchInputControl = withJsonFormsControlProps(SearchInputComponent);
